import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { AddressCardComponent } from './address-card.component';

@NgModule({
  declarations: [AddressCardComponent],
  imports: [
    CommonModule,
    TagModule,
    ButtonModule,
    NgxPermissionsModule.forChild()
  ],
  exports: [AddressCardComponent]
})
export class AddressCardModule {}
